import React from 'react';
import { NavLink } from 'react-router-dom';

const AddExpenseClaimCrumb = () => (
  <NavLink to="/human-resources/expense-claims/add">Add Expense Claim</NavLink>
);

export default AddExpenseClaimCrumb;
